import Shipping from './shipping';

export default Shipping;